
// 👇各个游戏的用户设定信息
export const oSettingOfGames = {
    'corgipharaoh': {
        auto: {
            default: false,
        },
    },
    'dice': {
        fast: false,
        auto: {
            default: false,
        },
        strategies: false
    },
    'spacedice': {
        animation: false,
        fast: false,
        auto: {
            default: false,
        },
    },
    'plinko': {
        animation: true,
        fast: false,
        auto: {
            default: false,
        },
    },
    'crash': {
        animation: true,
        auto: {
            default: false,
        },
    },
    'keno': {
        fast: false,
        auto: {
            default: false,
        },
    },
    'limbo': {
        animation: true,
        fast: false,
        auto: {
            default: false,
        },
    },
    'circle': {
        auto: {
            '0': false,
            '1': false,
            '2': false,
            '3': false,
        },
    },
    'hilo': {
        animation: true,
    },
    'stairs': {
        fast: false,
    },
    'mines': {
        auto: {
            default: false,
        },
    },
    'coinflip': {
        fast: false,
    },
    'cryptos': {
        animation: true,
        fast: false,
        auto: {
            default: false,
        },
    },
    'triple': {
        animation: true,
        auto: {
            default: false,
        },
    },
    'ring': {
        fast: false,
        animation: true,
        auto: {
            default: false,
        },
    },
    'tower': {
        fast: false,
        animation: true,
        auto: {
            default: false,
        },
    },
    'corgiwild': {
        fast: false,
        animation: true,
        auto: {
            default: false,
        },
    },
    redpacket: {
        fast: false,
    },
    goldenFlower: {
        fast: false,
        isChecked: false,
    },
    niuniu: {
        fast: false,
    },
};
